<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">

                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">
                                        <div class="page-body">
                                            <h5 class="pb-4">Job Preview Evaluation</h5>


                                            <div v-show="evalcard_state == 'use'">
                                                <div class="card">
                                                    <div class="card-header">
                                                        <h5>On-the-Job Evaluation</h5>
                                                    </div>

                                                    <div class="card-block table-border-style">
                                                        <div class="row">
                                                            <div class="col-lg-12 col-xl-12">

                                                                <ul class="nav nav-tabs md-tabs " role="tablist">
                                                                    <li class="nav-item">
                                                                        <a class="nav-link active" data-toggle="tab"
                                                                            href="#new_evaluation" role="tab">New
                                                                            Evaluation</a>
                                                                        <div class="slide"></div>
                                                                    </li>
                                                                    <li class="nav-item">
                                                                        <a class="nav-link" data-toggle="tab" href="#scorecard"
                                                                            role="tab">Evaluation Results</a>
                                                                        <div class="slide"></div>
                                                                    </li>
                                                                </ul>

                                                                <div class="tab-content card-block">

                                                                    <div class="tab-pane" id="scorecard" role="tabpanel">
                                                                        <div class="table-responsive" v-if="applicant.evaluation_answers.length > 0">
                                                                            <table class="table">
                                                                                <thead>
                                                                                    <th colspan=4>Question</th>
                                                                                    <th colspan=4>Answer</th>
                                                                                    <th colspan=4>Comment</th>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr v-for="item in applicant.evaluation_answers">
                                                                                        <td colspan=4>
                                                                                            <b>{{applicant.evaluation_question[item.questionno]}}</b>
                                                                                        </td>
                                                                                        <td colspan=4>
                                                                                            <p>{{item.answers}}</p>
                                                                                        </td>
                                                                                        <td colspan=4>
                                                                                            <p>{{item.comments}}</p>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        <div v-else>
                                                                            <h5 style="text-align: center;">Applicant
                                                                                has not been scored yet.</h5>
                                                                        </div>
                                                                    </div>

                                                                    <div class="tab-pane active" id="new_evaluation"
                                                                        role="tabpanel">
                                                                        <form role="form" v-on:submit.prevent="submitEvaluation">
                                                                            <div class="form-group row">
                                                                                <div class="col-sm-12" text-align='center'>
                                                                                    <b>JOB PREVIEW TEMPLATE FOR
                                                                                        PROSPECTIVE OPERATIONS
                                                                                        MANAGEMENT
                                                                                        TRAINEE </b><br />
                                                                                    (To be sent in by the
                                                                                    Restaurant/Bakery/Canteen Manager
                                                                                    within 24hours of job preview
                                                                                    completion)
                                                                                </div>
                                                                                <div class="col-lg-4 col-md-4 col-sm-12">
                                                                                    <label></label>
                                                                                    <input type="text" name="candidate_name"
                                                                                        class="form-control"
                                                                                        placeholder="Candidate"
                                                                                        readonly="readonly" v-model="applicant.firstname + ' ' + applicant.lastname" />
                                                                                </div>
                                                                                <div class="col-lg-4 col-md-4 col-sm-12">
                                                                                    <label></label>
                                                                                    <input type="text" name="time_in"
                                                                                        class="form-control" onfocus="(this.type='time')"
                                                                                        onblur="this.type='text'"
                                                                                        placeholder="Time In" required=""
                                                                                        v-model="answer.question_answer.question1[0].answer" />
                                                                                </div>

                                                                                <div class="col-lg-4 col-md-4 col-sm-12">
                                                                                    <label></label>
                                                                                    <input type="text" name="time_out"
                                                                                        class="form-control" onfocus="(this.type='time')"
                                                                                        onblur="this.type='text'"
                                                                                        placeholder="Time Out" required=""
                                                                                        v-model="answer.question_answer.question2[0].answer" />
                                                                                </div>
                                                                                <div class="col-lg-4 col-md-4 col-sm-12">
                                                                                    <label></label>
                                                                                    <input type="text" name="assessor"
                                                                                        class="form-control"
                                                                                        placeholder="Assessor" required=""
                                                                                        v-model="answer.question_answer.question3[0].answer" />
                                                                                </div>
                                                                                <div class="col-lg-4 col-md-4 col-sm-12">
                                                                                    <label></label>
                                                                                    <input type="text" name="shift_type"
                                                                                        class="form-control"
                                                                                        placeholder="Shift Type"
                                                                                        required="" v-model="answer.question_answer.question4[0].answer" />
                                                                                </div>
                                                                                <div class="col-lg-4 col-md-4 col-sm-12">
                                                                                    <label></label>
                                                                                    <input type="text" name="date"
                                                                                        class="form-control"
                                                                                        placeholder="Date" onfocus="(this.type='date')"
                                                                                        onblur="this.type='text'"
                                                                                        required="" v-model="answer.question_answer.question5[0].answer" />
                                                                                </div>
                                                                            </div>
                                                                            <div class="table-responsive">
                                                                                <table class="table table-hover table-default">

                                                                                    <thead>
                                                                                        <tr class="section-title">

                                                                                        </tr>
                                                                                        <tr>
                                                                                            <th colspan=4>JOB AREAS TO
                                                                                                BE
                                                                                                REVIEWED</th>
                                                                                            <th colspan=4>SPECIFICS
                                                                                                TASKS
                                                                                                CARRIED OUT BY
                                                                                                CANDIDATE
                                                                                                (SHADOW OPERATIONS)</th>
                                                                                            <th colspan=4>RESTAURANT/BAKERY/CANTEEN
                                                                                                MANAGER'S COMMENTS
                                                                                                (Objective comments
                                                                                                only)</th>
                                                                                        </tr>

                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td colspan=4>
                                                                                                <b>Restaurant/Bakery/Canteen
                                                                                                    Manager's Office
                                                                                                    (Managers' Roles
                                                                                                    and
                                                                                                    Responsibilities)</b>
                                                                                                <p>Note that
                                                                                                    candidates are to
                                                                                                    be given a brief of
                                                                                                    a typical
                                                                                                    restaurant's
                                                                                                    operations from
                                                                                                    opening to closing
                                                                                                    (including the
                                                                                                    different job roles
                                                                                                    that exist) and a
                                                                                                    typical day in the
                                                                                                    life of restaurant
                                                                                                    shift manager.
                                                                                                    After which they
                                                                                                    are expected to
                                                                                                    participate in
                                                                                                    activities in key
                                                                                                    section's activity</p>
                                                                                            </td>
                                                                                            <td colspan=4>
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answer.question_answer.question6[0].answer"></textarea>
                                                                                            </td>
                                                                                            <td colspan=4>
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answer.question_answer.question6[0].comment"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=4>
                                                                                                <b>Back-of-House
                                                                                                    Operations (Shadow
                                                                                                    Operations)</b>
                                                                                                <br>
                                                                                                <u>Cook Station &
                                                                                                    Fryers Station </u>
                                                                                                <p>Candidate is
                                                                                                    expected
                                                                                                    participate in food
                                                                                                    production process
                                                                                                    and Back-area
                                                                                                    Hygiene</p>
                                                                                            </td>
                                                                                            <td colspan=4>
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answer.question_answer.question7[0].answer"></textarea>
                                                                                            </td>
                                                                                            <td colspan=4>
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answer.question_answer.question7[0].comment"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=4>
                                                                                                <b>Front of House
                                                                                                    Operations &
                                                                                                    Customer Service
                                                                                                    (Shadow Operations)</b>
                                                                                                <p><u>Cashiers & Lobby
                                                                                                        Station</u> -
                                                                                                    Use of Till ( POS
                                                                                                    Systems) and
                                                                                                    customer service</p>
                                                                                                <p>Candidates are
                                                                                                    expected to
                                                                                                    demonstrate
                                                                                                    knowledge of
                                                                                                    customer service
                                                                                                    and selling skills
                                                                                                    at the cashiers
                                                                                                    station and at the
                                                                                                    Lobby</p>
                                                                                            </td>
                                                                                            <td colspan=4>
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answer.question_answer.question8[0].answer"></textarea>
                                                                                            </td>
                                                                                            <td colspan=4>
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answer.question_answer.question8[0].comment"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=4>
                                                                                                <b>Inventory Management
                                                                                                    (Shadow Operations)</b>
                                                                                                <p>Forecasting,
                                                                                                    ordering, receiving
                                                                                                    standards, storage,
                                                                                                    FIFO and storage.
                                                                                                    Stock-count. Use of
                                                                                                    Bin cards and
                                                                                                    documentation.</p>
                                                                                            </td>
                                                                                            <td colspan=4>
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answer.question_answer.question9[0].answer"></textarea>
                                                                                            </td>
                                                                                            <td colspan=4>
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answer.question_answer.question9[0].comment"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=4>
                                                                                                <b>Shift Changeover and
                                                                                                    Closing</b>
                                                                                            </td>
                                                                                            <td colspan=4>
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answer.question_answer.question10[0].answer">
                                                                                                    </textarea>
                                                                                            </td>
                                                                                            <td colspan=4>
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answer.question_answer.question10[0].comment"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td></td>
                                                                                        </tr>

                                                                                        <tr>
                                                                                            <td colspan=6>
                                                                                                <b>Please score the
                                                                                                    following on a
                                                                                                    scale of 1-5; 1
                                                                                                    being the lowest
                                                                                                    and 5 being the
                                                                                                    highest.</b>
                                                                                            </td>
                                                                                            <td colspan=6>
                                                                                                <b>Comments (To further
                                                                                                    buttress your
                                                                                                    score)</b>
                                                                                            </td>
                                                                                        </tr>

                                                                                        <tr>
                                                                                            <td colspan=4>Punctuality</td>
                                                                                            <td colspan=2>
                                                                                                <input type="number"
                                                                                                    min="1" class="form-control"
                                                                                                    max="5" value="1"
                                                                                                    name=""
                                                                                                    v-model.number="answer.question_answer.question11[0].answer"
                                                                                                    v-on:keyup="calculateScore" />
                                                                                            </td>
                                                                                            <td colspan=6>
                                                                                                <textarea class="form-control"
                                                                                                    name="" required=""
                                                                                                    v-model="answer.question_answer.question11[0].comment"
                                                                                                    v-on:keyup="calculateScore"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=4>Attitude</td>
                                                                                            <td colspan=2>
                                                                                                <input type="number"
                                                                                                    min="1" class="form-control"
                                                                                                    max="5" value="1"
                                                                                                    name=""
                                                                                                    v-model.number="answer.question_answer.question12[0].answer"
                                                                                                    v-on:keyup="calculateScore" />
                                                                                            </td>
                                                                                            <td colspan=6>
                                                                                                <textarea class="form-control"
                                                                                                    name="" required=""
                                                                                                    v-model="answer.question_answer.question12[0].comment"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=4>Enthusiasm
                                                                                                and Passion
                                                                                                exhibited</td>
                                                                                            <td colspan=2>
                                                                                                <input type="number"
                                                                                                    min="1" class="form-control"
                                                                                                    max="5" value="1"
                                                                                                    name=""
                                                                                                    v-model.number="answer.question_answer.question13[0].answer"
                                                                                                    v-on:keyup="calculateScore" />
                                                                                            </td>
                                                                                            <td colspan=6>
                                                                                                <textarea class="form-control"
                                                                                                    name="" required=""
                                                                                                    v-model="answer.question_answer.question13[0].comment"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=4>Fit for
                                                                                                fast-paced role
                                                                                                and Waje Smart Solutions culture</td>
                                                                                            <td colspan=2>
                                                                                                <input type="number"
                                                                                                    min="1" class="form-control"
                                                                                                    max="5" value="1"
                                                                                                    name=""
                                                                                                    v-model.number="answer.question_answer.question14[0].answer"
                                                                                                    v-on:keyup="calculateScore" />
                                                                                            </td>
                                                                                            <td colspan=6>
                                                                                                <textarea class="form-control"
                                                                                                    name="" required=""
                                                                                                    v-model="answer.question_answer.question14[0].comment"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=4>Disposition
                                                                                                and
                                                                                                Interpersonal skills</td>
                                                                                            <td colspan=2>
                                                                                                <input type="number"
                                                                                                    min="1" class="form-control"
                                                                                                    max="5" value="1"
                                                                                                    name=""
                                                                                                    v-model.number="answer.question_answer.question15[0].answer"
                                                                                                    v-on:keyup="calculateScore" />
                                                                                            </td>
                                                                                            <td colspan=6>
                                                                                                <textarea class="form-control"
                                                                                                    name="" required=""
                                                                                                    v-model="answer.question_answer.question15[0].comment"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=4>Ability to
                                                                                                lead, take
                                                                                                charge, takes intiative</td>
                                                                                            <td colspan=2>
                                                                                                <input type="number"
                                                                                                    min="1" class="form-control"
                                                                                                    max="5" value="1"
                                                                                                    name=""
                                                                                                    v-model.number="answer.question_answer.question16[0].answer"
                                                                                                    v-on:keyup="calculateScore" />
                                                                                            </td>
                                                                                            <td colspan=6>
                                                                                                <textarea class="form-control"
                                                                                                    name="" required=""
                                                                                                    v-model="answer.question_answer.question16[0].comment"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=4><b>Total:</b></td>
                                                                                            <td colspan=8>
                                                                                                <input type="text" name=""
                                                                                                    class="form-control"
                                                                                                    readonly="readonly"
                                                                                                    v-model="answer.question_answer.question17[0].answer" />
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=6>
                                                                                                <p>Candidate's Observed
                                                                                                    Strengths or
                                                                                                    preferences</p>
                                                                                            </td>
                                                                                            <td colspan=6>
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answer.question_answer.question18[0].answer"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=6>
                                                                                                <p>Candidate's observed
                                                                                                    weakness or areas
                                                                                                    of less interest
                                                                                                </p>
                                                                                            </td>
                                                                                            <td colspan=6>
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answer.question_answer.question19[0].answer"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=6>
                                                                                                <p>Assessor's Summary
                                                                                                    Assessment of
                                                                                                    Candidate</p>
                                                                                            </td>
                                                                                            <td colspan=6>
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answer.question_answer.question20[0].answer"></textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=6>
                                                                                                <b>Okay to Hire?</b>
                                                                                            </td>
                                                                                            <td colspan=6 style="font-size: 16px;">

                                                                                                <div class="radio radio-outline radio-inline">
                                                                                                    <label>
                                                                                                        <input type="radio"
                                                                                                            name="hire"
                                                                                                            v-model="answer.question_answer.question21[0].answer"
                                                                                                            value="YES">
                                                                                                        Yes
                                                                                                    </label>
                                                                                                </div>
                                                                                                <div class="radio radio-outline radio-inline">
                                                                                                    <label>
                                                                                                        <input type="radio"
                                                                                                            name="hire"
                                                                                                            v-model="answer.question_answer.question21[0].answer"
                                                                                                            value="NO">
                                                                                                        No
                                                                                                    </label>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>

                                                                            <div class="form-group">
                                                                                <button class="btn btn-primary btn-sm">Submit</button>
                                                                            </div>
                                                                        </form>

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<style scoped>
    .section-title {
        text-align: center;
    }

    .section-title td {
        text-transform: uppercase;
        font-weight: bold;
    }

    td,
    th {
        white-space: normal !important;
        word-wrap: break-word;
    }

    table {
        table-layout: fixed;
    }

    textarea {
        height: 150px;
    }
</style>
<script>
    import navbar1 from '../components/Navbar1.vue'
    import navbar2 from '../components/Navbar2.vue'

    export default {
        name: 'ScoreCard',

        data() {
            return {
                answer: {
                    appid: "",
                    user_id: this.$store.getters.user_data.data.id,
                    question_answer: {
                        question1: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question2: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question3: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question4: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question5: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question6: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question7: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question8: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question9: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question10: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question11: [
                            {
                                answer: 1,
                                comment: ""
                            }
                        ],
                        question12: [
                            {
                                answer: 1,
                                comment: ""
                            }
                        ],
                        question13: [
                            {
                                answer: 1,
                                comment: ""
                            }
                        ],
                        question14: [
                            {
                                answer: 1,
                                comment: ""
                            }
                        ],
                        question15: [
                            {
                                answer: 1,
                                comment: ""
                            }
                        ],
                        question16: [
                            {
                                answer: 1,
                                comment: ""
                            }
                        ],
                        question17: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question18: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question19: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question20: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ],
                        question21: [
                            {
                                answer: "",
                                comment: ""
                            }
                        ]
                    }
                },
                evalcard_state: "use",
                applicant_id: "",
                applicant: {
                    evaluation_answers: []
                },
            }
        },

        components: {
            navbar1,
            navbar2
        },

        mounted() {

            this.evalcard_state = 'use'
            this.applicant_id = this.$route.params.id

            this.answer.appid = this.$route.params.id


            this.init()
        },

        methods: {

            init: function () {
                this.getApplicantInformation()
            },


            getApplicantInformation: function () {

                // var loading_html = '<div style="height:150px;width:150px;margin: 0 auto;"><img style="width: 100%;" src="https://i.ya-webdesign.com/images/minimalist-transparent-loading-gif-6.gif" /></div>'

                // this.$swal.fire({
                //     title: "<h5></h5>", 
                //     html: loading_html,  
                //     showConfirmButton: false,
                //     showCancelButton: false,
                //     allowOutsideClick: false
                // })

                var request = {
                    what: 'PracticalEvaluationScores',
                    params: {
                        appid: this.applicant_id,
                        evaluator: this.$store.getters.user_data.data.id
                    }
                }

                this.$socket.makeGetRequest(request)
                    .then((response) => {
                        if (response.type == 'PracticalEvaluationScores') {
                            this.applicant = response.data[0]
                            console.log(this.applicant)
                            this.$swal.close()
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                    })
            },

            calculateScore: function () {
                let a = this.answer.question_answer
                let s1 = (a.question11[0].answer !== "") ? a.question11[0].answer : 1
                let s2 = (a.question12[0].answer !== "") ? a.question12[0].answer : 1
                let s3 = (a.question13[0].answer !== "") ? a.question13[0].answer : 1
                let s4 = (a.question14[0].answer !== "") ? a.question14[0].answer : 1
                let s5 = (a.question15[0].answer !== "") ? a.question15[0].answer : 1
                let s6 = (a.question16[0].answer !== "") ? a.question16[0].answer : 1

                let score = s1 + s2 + s3 + s4 + s5 + s6

                a.question17[0].answer = score
            },

            submitEvaluation: function () {

                let request = {
                    what: "SubmitPracticalEvaluation",
                    data: this.answer
                }
                console.log(JSON.stringify(request))
                this.$socket.makePostRequest(request)
                    .then((response) => {
                        if (response.type == 'SubmitPracticalEvaluation') {
                            //console.log(response)
                            this.$swal.fire("Success", "Record created.", "success")

                            setTimeout(() => {
                                window.location.reload()
                            }, 3000)
                        }
                    })
                    .catch((error) => {
                        this.$swal.fire("Error", error.data.message, 'error')
                        console.log(error)
                    })
            }
        },
        computed: {

        }
    }
</script>